<template>
  <div id="face-search" class="modal">
    <div class="face-fm">
      <div class="face-bg">
        <div class="face-search-uploader">
          <div id="app">
            <h4 class="mt-3 mb-3">{{$t('Album.albumviewFaceRecognition.Uploadfacial')}}</h4>
            <el-upload
              class="face-uploader"
              :auto-upload="false"
              action=""
              :show-file-list="false"
              :on-change="onchange"
            >
              <img v-if="imageUrl" :src="imageUrl" class="face-avatar" />
              <i v-else class="el-icon-plus face-uploader-icon"></i>
            </el-upload>
            <p class="mt-3 mb-3">
              {{$t('Album.albumviewFaceRecognition.Uploadtitle')}}
            </p>
            <a href="javascript:" @click="faceMessage">  {{$t('Album.albumviewFaceRecognition.Upload')}} </a>
            <div class="face-btn mt-3 mb-3">
              <button
                v-show="!loading"
                type="button"
                class="btn btn-block btn-primary"
                :data-hover="$t('Album.albumviewFaceRecognition.facesearch')"
                @click="search"
              >
                <i class="fa fa-plus fa-fw fa-sm mr-1" aria-hidden="true"></i
                ><i>{{$t('Album.albumviewFaceRecognition.Startfacesearch')}}</i>
              </button>
              <button
                v-show="loading"
                class="btn btn-block btn-primary"
                type="button"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from "../../api/httpApi/base";
import { Message } from "element-ui";
export default {
  data() {
    return {
      searchFile: null,
      imageUrl: "",
      coid: "",
      imageUploadUrl: `${base.dev}/services/app/PhotoGalleryConfigAppSerivce/UploadFaceSearchPhoto`,
      loading: false,
    };
  },
  mounted() {},
  created() {},
  methods: {
    faceMessage() {
      $("#face-search").modal("hide");
      this.$router.push({ path: `/foot/face_illustrate` });
    },
    clear() {
      this.imageUrl = "";
      this.coid = "";
      this.searchFile = null;
    },
    show(coid) {
      this.coid = coid;
      $("#face-search").modal("show");
    },
    hide() {
      $("#face-search").modal("hide");
    },
    onchange(file, fileList) {
      if (file) {
        switch (file.raw.type) {
          case "image/jpeg":
            break;
          case "image/png":
            break;
          default:
            this.$message({
              message: "請選擇jpg/png格式",
            });
            return;
        }
        this.searchFile = file;
        this.imageUrl = window.URL.createObjectURL(this.searchFile.raw);
      }
    },
    base64ToBlob(base64) {
      let arr = base64.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    fileToBase64(file) {
      this.loading = true;
      let _this = this;
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = function (e) {
        let n = _this.base64ToBlob(e.target.result);
        let formData = new FormData();
        let reqUrl = _this.imageUploadUrl + "?coid=" + _this.coid;
        formData.append("file", n, file.raw.name);
        _this.$api.albumApi
          .uploadImages(reqUrl, formData)
          .then((res) => {
            _this.loading = false;
            if (res.data.success) {
              _this.hide();
              _this.$emit(
                "faceSearchResult",
                _this.searchFile,
                res.data.result
              );
            } else {
              _this.$message({
                type: "error",
                message: res.data.error.message,
              });
            }
          })
          .catch((err) => {
            _this.loading = false;
            _this.hide();
            console.log(err);
          });
      };
    },
    search() {
      if (this.searchFile) {
        this.fileToBase64(this.searchFile);
      } else {
        this.$message({
          message: "請選擇文件",
        });
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Album/albumviewFaceRecognition.vue